import "core-js/modules/es6.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import Vue from 'vue';
import util from '@tencent/vft-common/util';
import env from '@tencent/vft-common/env';
import atom from '@tencent/vft-atom';
import * as url from '@tencent/vft-common/url';
import AID from '@tencent/vft-common/AID';
import { openUrl } from "./openUrl";
export function openVip(_x) {
  return _openVip.apply(this, arguments);
}

function _openVip() {
  _openVip = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(actId) {
    var ptag, sandbox, oAidStr, aid, aidStr, absUrl, h5Url;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ptag = util.getUrlParam('ptag') || util.getUrlParam('PTAG') || util.getUrlParam('adtag') || util.getUrlParam('ADTAG') || '';
            sandbox = util.getUrlParam('sandbox') ? 1 : '';
            oAidStr = util.getUrlParam('aid');
            aid = new AID(oAidStr);
            aid.set(13, actId);
            aidStr = aid.toString();

            if (!(env.isIpad && env.isApp)) {
              _context.next = 13;
              break;
            }

            atom.invoke('PurchaseStatus');
            atom.on('PurchaseStatusCallback', function (res) {
              if (res.result.state === 'PurchaseSuccess') {
                window.location.reload();
              }
            });
            absUrl = url.buildUrl('https://film.qq.com/ipad/upay/index.html', {
              lp: 1,
              sandbox: sandbox,
              hlwactId: actId,
              dsp: 1,
              ru: window.location.href,
              ptag: ptag,
              aid: aidStr
            }, true);
            absUrl = 'txvideo://v.qq.com/PopHollywoodH5Activity?url=' + encodeURIComponent(absUrl);
            atom.invoke('openView', {
              url: absUrl
            });
            return _context.abrupt("return");

          case 13:
            h5Url = url.buildUrl('https://film.qq.com/weixin/upay.html', {
              lp: 1,
              hlwactId: actId,
              sandbox: sandbox,
              ru: window.location.href,
              ptag: ptag,
              aid: aidStr
            }, true);
            openUrl(h5Url);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _openVip.apply(this, arguments);
}

export function mixinOpenVip() {
  Vue.mixin({
    methods: {
      openVip: openVip
    }
  });
}